export default __webpack_public_path__ + "static/provider-search-56ee71839c9f1bfaf0b6912a50efc633.png";